<template>
	<div class="w-100 overflow-h position-relative h-100vh" style="--themescolor:#2e82e3;width: 100%;overflow-y: hidden;overflow-x: hidden;">
		
		<div style="padding-top: 1rem;"></div>
		<div class="position-absolute left-0 px-6 h-88r flex-center" style="top: 50px;color: #1989fa;" @click="goBack">
			
			<div class="flex-col-center">
				<div class="icon transition-all05" style="color: #1989fa;transform: translate(25%, 0%) rotate(45deg) scale(1); border-left: 1px solid rgb(68, 68, 68); border-bottom: 1px solid rgb(68, 68, 68); width: 11px; height: 11px;z-index: 9;"></div>
			</div>
			<div class="flex-col-center" style="margin-left: 8px;">
				<span>返回</span>
			</div>
		</div>
		
		
		<!-- <div class="right-top-sign"></div> -->
		<!-- <div class="left-bottom-sign"></div> -->
		<div class="position-relative h-100r" style="height: 80px;">
			<!-- <div class="position-absolute left-0 bottom-0" style="font-size: 60px; color: rgb(248, 248, 248);">兑换</div> -->
		</div>
		<div class="px-6 pt-6">
			<div class="p-3 flex-around text-666 rounded-10" style="background: rgb(248, 246, 252);">
				<div class="flex-1 flex-col-start">
					<p class="font-28"><span>兑换码</span></p>
					<div class="pt-2">
						<div class="uni-input-wrapper">
							<van-field type="text" style="background: none;padding: 0;font-size: 18px;" v-model="code" center placeholder="请输入兑换码"
							 :error-message="cheeckCode" maxlength="20" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="w-100 border-box my-6 px-6">
			<div class="but-main w-100 text-white h-88r rounded-100 font-32 " @click="post">
				<p style="color: #fff;"><span>兑换</span></p>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	import {
		Toast,NumberKeyboard
	} from 'vant'
	Vue.use(Toast)
	Vue.use(NumberKeyboard)
	
	var timer = null
	export default {
		data() {
			return {
				code: ''
			}
		},
		computed: {
			cheeckCode() {
				if (this.code.length == '') {
					return ''
				} else if (this.code.length !== 9) {
					return '兑换码错误'
				} else {
					return ''
				}
			}
		},
		methods: {
			post(){
				if(this.cheeckCode || this.code.length !== 9){
					this.$toast.fail('兑换码错误')
					return
				}
				this.$ApiUtil.Codes.post({
					code: this.code
				}).then( (res) => {
					this.$dialog.alert({
						message: res.message
					}).then( () => {
						if(res.status){
							this.$router.push('/member-center')
						}
					} )
				} )
			},
			goBack(){
				this.$router.push('/')
			},
		}
	}
</script>
<style type="text/css" scoped>
	/* UI基础库 */
	/* 公共变量 */
	body {
		--primary: #007bff;
		/* 蓝(原色)--主要的*/
		--secondary: #6c757d;
		/* 灰蓝--次要的*/
		--success: #28a745;
		/* 绿色--成功的 */
		--danger: #dc3545;
		/* 深红--危险 */
		--warning: #ffc107;
		/* 黄(原色)--警告*/
		--info: #17a2b8;
		/* 绿松石色--信息*/
		--light: #f8f9fa;
		/* 亮白色*/
		--dark: #343a40;
		/* 暗黑*/
		--muted: #6c757d;
		/* 灰黑*/
		--white: #fff;
		/* 白色*/
		--lightmuted: #b2b2b2;
		/* 浅灰色*/
		--bordercolor: #f6f7f8;
		/* 默认是取 #dee2e6,现在取背景颜色的值 */
		--backgroundcolor: #f6f7f8
	}

	/* 页面主色--绿色#4eae31 */
	/* 主题颜色的应用:在vue页面上引入<view :style="{ '--themescolor': themes.color }">值,只要--themescolor的名字对应上,该themes.color值会传到该公共css里 */
	/* --themescolor:var(--themescolor);  */
	/* 防止图片闪一下 */
	uni-image {
		will-change: transform
	}

	/* 指定页面安全距离 */
	uni-page-body {
		--safe-area-inset-top: 0px;
		--safe-area-inset-right: 0px;
		--safe-area-inset-bottom: 0px;
		--safe-area-inset-left: 0px
	}

	@supports (top:constant(safe-area-inset-top)) {
		uni-page-body {
			--safe-area-inset-top: constant(safe-area-inset-top);
			--safe-area-inset-right: constant(safe-area-inset-right);
			--safe-area-inset-bottom: constant(safe-area-inset-bottom);
			--safe-area-inset-left: constant(safe-area-inset-left)
		}
	}

	@supports (top:env(safe-area-inset-top)) {
		uni-page-body {
			--safe-area-inset-top: env(safe-area-inset-top);
			--safe-area-inset-right: env(safe-area-inset-right);
			--safe-area-inset-bottom: env(safe-area-inset-bottom);
			--safe-area-inset-left: env(safe-area-inset-left)
		}
	}

	/* 用法:<view class="det-foot" style="border-bottom: var(--safe-area-inset-bottom) solid #FFFFFF;">
或者:.det-foot { height: calc(50px + var(--safe-area-inset-bottom)); } 
    .detail { padding-bottom: calc(60px + var(--safe-area-inset-bottom)); }*/
	.safearea-bb {
		border-bottom: var(--safe-area-inset-bottom) solid transparent
	}

	.safearea-bb-white {
		border-bottom: var(--safe-area-inset-bottom) solid #fff
	}

	.safearea-bb-theme {
		border-bottom: var(--safe-area-inset-bottom) solid var(--themescolor)
	}

	.safearea-bb-bg {
		border-bottom: var(--safe-area-inset-bottom) solid var(--backgroundcolor)
	}

	.safearea-bt {
		border-top: var(--safe-area-inset-top) solid transparent
	}

	.safearea-bt-white {
		border-top: var(--safe-area-inset-top) solid #fff
	}

	.safearea-bt-theme {
		border-top: var(--safe-area-inset-top) solid var(--themescolor)
	}

	.safearea-bt-bg {
		border-top: var(--safe-area-inset-top) solid var(--backgroundcolor)
	}

	.safearea-pb {
		padding-bottom: var(--safe-area-inset-bottom) solid transparent
	}

	.safearea-pb-white {
		padding-bottom: var(--safe-area-inset-bottom) solid #fff
	}

	.safearea-pb-theme {
		padding-bottom: var(--safe-area-inset-bottom) solid var(--themescolor)
	}

	.safearea-pb-bg {
		padding-bottom: var(--safe-area-inset-bottom) solid var(--backgroundcolor)
	}

	.safearea-pt {
		padding-top: var(--safe-area-inset-top) solid transparent
	}

	.safearea-pt-white {
		padding-top: var(--safe-area-inset-top) solid #fff
	}

	.safearea-pt-theme {
		padding-top: var(--safe-area-inset-top) solid var(--themescolor)
	}

	.safearea-pt-bg {
		padding-top: var(--safe-area-inset-top) solid var(--backgroundcolor)
	}

	.clearfix {
		zoom: 1
	}

	.clearfix:after {
		content: " ";
		display: table;
		clear: both
	}

	/* 阴影(备注：只能用px为单位，用rpx无效) */
	.shadow-sm {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1)
	}

	/* 浅色投影 */
	.shadow {
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
	}

	/* 基础投影 */
	.shadow-lg {
		box-shadow: 0 8px 24px rgba(114, 130, 138, .8)
	}

	/* 深色投影 */
	/* 定位 */
	.position-absolute {
		position: absolute
	}

	.position-fixed {
		position: fixed
	}

	.position-relative {
		position: relative
	}

	.position-sticky {
		position: -webkit-sticky;
		position: sticky
	}

	.left-0 {
		left: 0
	}

	.left-100 {
		left: 100%
	}

	.top-0 {
		top: 0
	}

	.top-44p {
		top: 44px
	}

	.top-100 {
		top: 100%
	}

	.bottom-0 {
		bottom: 0
	}

	.bottom-100 {
		bottom: 100%
	}

	.right-0 {
		right: 0
	}

	.right-100 {
		right: 100%
	}

	/* 宽高 */
	.w-100 {
		width: 100%
	}

	.w-50 {
		width: 50%
	}

	.w-25 {
		width: 25%
	}

	.h-100 {
		height: 100%
	}

	.h-75 {
		height: 75%
	}

	.h-50 {
		height: 50%
	}

	.h-25 {
		height: 25%%
	}

	/* 新增 */
	.w-auto {
		width: auto
	}

	.w-44p {
		width: 44px
	}

	.w-88r {
		width: 44px
	}

	.w-100r {
		width: 50px
	}

	.h-100vh {
		height: 100vh
	}

	.h-50vh {
		height: 50vh
	}

	.h-33vh {
		height: 33vh
	}

	.h-25vh {
		height: 25vh
	}

	.w-100vw {
		width: 100vw
	}

	.w-50vw {
		width: 50vw
	}

	.w-33vw {
		width: 33vw
	}

	.w-25vw {
		width: 25vw
	}

	.h-auto {
		height: auto
	}

	.h-28p {
		height: 28px
	}

	/* 搜索框的标准高度 */
	.h-30p {
		height: 30px
	}

	.h-60r {
		height: 30px
	}

	.h-44p {
		height: 44px
	}

	.h-88r {
		height: 44px
	}

	.h-100r {
		height: 50px
	}

	.h-625r {
		height: 312px
	}

	.h-1250r {
		height: 625px
	}

	/* 字体 */
	.font {
		font-size: 12px
	}

	.font-sm {
		font-size: 10px
	}

	.font-md {
		font-size: 15px
	}

	.font-lg {
		font-size: 20px
	}

	.font-big {
		font-size: 30px
	}

	.font-weight {
		font-weight: 700 !important
	}

	.font-weight-100 {
		font-weight: 100 !important
	}

	/* 以下为新增的 */
	.font-0 {
		font-size: 0
	}

	/* view下的image子元素，image不设高度的话，会不占满父级元素，这时加上font-size: 0;就能把空出的2px空白给填上 */
	.font-60 {
		font-size: 30px
	}

	.font-40 {
		font-size: 20px
	}

	.font-36 {
		font-size: 18px
	}

	.font-32 {
		font-size: 16px
	}

	.font-30 {
		font-size: 15px
	}

	.font-28 {
		font-size: 14px
	}

	.font-24 {
		font-size: 12px
	}

	.font-20 {
		font-size: 10px
	}

	.word-breakall {
		word-break: break-all
	}

	.font-arial {
		font-family: arial
	}

	/* 数字专用，数字用这个字体会比默认的好看 */
	/* 字距 */
	.letter-sp2 {
		letter-spacing: 1px
	}

	.letter-sp4 {
		letter-spacing: 2px
	}

	.letter-sp10 {
		letter-spacing: 5px
	}

	.line-h0 {
		line-height: 0 !important
	}

	.line-h {
		line-height: 1 !important
	}

	.line-h-sm {
		line-height: 1.2 !important
	}

	.line-h-md {
		line-height: 1.5 !important
	}

	.line-h-lg {
		line-height: 2 !important
	}

	.line-h-big {
		line-height: 3 !important
	}

	.line-through {
		text-decoration: line-through
	}

	.text-center {
		text-align: center
	}

	.text-left {
		text-align: left
	}

	.text-right {
		text-align: right
	}

	/* scroll-view */
	.scroll-row {
		width: 100%;
		white-space: nowrap
	}

	/* 新增 */
	.text-nowrap {
		white-space: nowrap;
		word-wrap: normal
	}

	/* 强制不换行 */
	.text-wrap {
		white-space: normal;
		word-wrap: break-word;
		word-break: break-all
	}

	/* 强制换行(且所有文字是breakall),但遇到一个换行符才会换行(不保留空格) */
	.text-pre-line {
		white-space: pre-line;
		word-wrap: break-word;
		word-break: break-all
	}

	/*自动换行(且所有文字是breakall),遇到一个换行符才会换行 (保留空格，但多个空格合并成一个)*/
	.text-pre-wrap {
		white-space: pre-wrap;
		word-wrap: break-word;
		word-break: break-all
	}

	/*自动换行(且所有文字是breakall),遇到一个换行符才会换行(保留全部空格)  */
	.border-box {
		box-sizing: border-box !important
	}

	.content-box {
		box-sizing: initial !important
	}

	.row {
		box-sizing: border-box !important;
		display: -webkit-box !important;
		display: -webkit-flex !important;
		display: flex !important;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		flex-direction: row;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap
	}

	/* 横向flex但会换行 */
	[class*="col-"],
	[class*="span-"],
	[class*="span24-"] {
		min-height: 1px;
		box-sizing: border-box !important
	}

	/* 栅栏一 */
	.col-1 {
		width: 31px
	}

	.col-2 {
		width: 62px
	}

	.col-3 {
		width: 93px
	}

	.col-4 {
		width: 125px
	}

	.col-5 {
		width: 156px
	}

	.col-6 {
		width: 187px
	}

	.col-7 {
		width: 218px
	}

	.col-8 {
		width: 250px
	}

	.col-9 {
		width: 281px
	}

	.col-10 {
		width: 312px
	}

	.col-11 {
		width: 343px
	}

	.col-12 {
		width: 375px
	}

	/* 栅栏二 */
	.span-1 {
		width: 5%
	}

	.span-2 {
		width: 10%
	}

	.span-3 {
		width: 15%
	}

	.span-4 {
		width: 20%
	}

	.span-5 {
		width: 25%
	}

	.span-6 {
		width: 30%
	}

	.span-7 {
		width: 35%
	}

	.span-8 {
		width: 40%
	}

	.span-9 {
		width: 45%
	}

	.span-10 {
		width: 50%
	}

	.span-11 {
		width: 55%
	}

	.span-12 {
		width: 60%
	}

	.span-13 {
		width: 65%
	}

	.span-14 {
		width: 70%
	}

	.span-15 {
		width: 75%
	}

	.span-16 {
		width: 80%
	}

	.span-17 {
		width: 85%
	}

	.span-18 {
		width: 90%
	}

	.span-19 {
		width: 95%
	}

	.span-20 {
		width: 100%
	}

	/* 栅栏三 */
	.span24-1 {
		width: 4.17%
	}

	.span24-2 {
		width: 8.33%
	}

	.span24-3 {
		width: 12.5%
	}

	.span24-4 {
		width: 16.67%
	}

	.span24-5 {
		width: 20.83%
	}

	.span24-6 {
		width: 25%
	}

	.span24-7 {
		width: 29.17%
	}

	.span24-8 {
		width: 33.33%
	}

	.span24-9 {
		width: 37.5%
	}

	.span24-10 {
		width: 41.67%
	}

	.span24-11 {
		width: 45.83%
	}

	.span24-12 {
		width: 50%
	}

	.span24-13 {
		width: 54.17%
	}

	.span24-14 {
		width: 58.33%
	}

	.span24-15 {
		width: 62.5%
	}

	.span24-16 {
		width: 66.67%
	}

	.span24-17 {
		width: 70.83%
	}

	.span24-18 {
		width: 75%
	}

	.span24-19 {
		width: 79.17%
	}

	.span24-20 {
		width: 83.33%
	}

	.span24-21 {
		width: 87.5%
	}

	.span24-22 {
		width: 91.67%
	}

	.span24-23 {
		width: 95.83%
	}

	.span24-24 {
		width: 100%
	}

	/* button按钮 */
	.but-pe-none {
		background: rgba(0, 0, 0, .3) !important;
		color: #fff;
		border: 0 !important;
		pointer-events: none !important;
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center
	}

	/* 置灰的按钮(不可点击的按钮)，这个class写在view层，按钮文字写在view层包住的text层里 */
	.but-pe-none-rgb02 {
		background: rgba(0, 0, 0, .2) !important;
		color: #fff;
		border: 0 !important;
		pointer-events: none !important;
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center
	}

	/* 置灰的按钮(不可点击的按钮)，这个class写在view层，按钮文字写在view层包住的text层里 */
	.but-main {
		/* background: var(--themescolor) !important; */
		color: #fff;
		border: 0 !important;
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		background: #89c0fc;
	}

	/* 置灰的按钮(不可点击的按钮)，这个class写在view层，按钮文字写在view层包住的text层里 */
	.but-main-rgb02 {
		background: var(--themesrgba02) !important;
		color: var(--themescolor);
		border: 0 !important;
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center
	}

	/* 置灰的按钮(不可点击的按钮)，这个class写在view层，按钮文字写在view层包住的text层里 */
	.pointer-none {
		pointer-events: none
	}

	/* 禁止点击 */
	.pointer-auto {
		pointer-events: auto
	}

	/* 父元素pointer-none后子元素可以用 pointer-auto这样只能点击子元素*/
	/* flex布局 */
	.d-flex {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex
	}

	.d-grid {
		display: grid
	}

	.d-block {
		display: block
	}

	.d-inline-block {
		display: inline-block
	}

	.flex-1 {
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1
	}

	.flex-2 {
		-webkit-box-flex: 2;
		-webkit-flex: 2;
		flex: 2
	}

	.flex-3 {
		-webkit-box-flex: 3;
		-webkit-flex: 3;
		flex: 3
	}

	.flex-4 {
		-webkit-box-flex: 4;
		-webkit-flex: 4;
		flex: 4
	}

	.flex-5 {
		-webkit-box-flex: 5;
		-webkit-flex: 5;
		flex: 5
	}

	.flex-column {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		flex-direction: column
	}

	.flex-row {
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		flex-direction: row
	}

	.flex-wrap {
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap
	}

	.flex-nowrap {
		-webkit-flex-wrap: nowrap;
		flex-wrap: nowrap
	}

	.flex-shrink {
		-webkit-flex-shrink: 0;
		flex-shrink: 0
	}

	.j-start {
		-webkit-box-pack: start;
		-webkit-justify-content: flex-start;
		justify-content: flex-start
	}

	.j-center {
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center
	}

	.j-end {
		-webkit-box-pack: end;
		-webkit-justify-content: flex-end;
		justify-content: flex-end
	}

	.j-sb {
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		justify-content: space-between
	}

	.a-center {
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center
	}

	.a-start {
		-webkit-box-align: start;
		-webkit-align-items: flex-start;
		align-items: flex-start
	}

	.a-end {
		-webkit-box-align: end;
		-webkit-align-items: flex-end;
		align-items: flex-end
	}

	.a-baseline {
		-webkit-box-align: baseline;
		-webkit-align-items: baseline;
		align-items: baseline
	}

	.a-stretch {
		-webkit-box-align: stretch;
		-webkit-align-items: stretch;
		align-items: stretch
	}

	.a-self-start {
		-webkit-align-self: flex-start;
		align-self: flex-start
	}

	.a-self-auto {
		-webkit-align-self: auto;
		align-self: auto
	}

	.a-self-end {
		-webkit-align-self: flex-end;
		align-self: flex-end
	}

	.a-self-stretch {
		-webkit-align-self: stretch;
		align-self: stretch
	}

	.a-self-baseline {
		-webkit-align-self: baseline;
		align-self: baseline
	}

	/* 以下为新增 */
	/* 垂直对齐方式(可用于任何布局) */
	.v-baseline {
		vertical-align: initial
	}

	/* 默认。元素放置在父元素的基线上 */
	.v-sub {
		vertical-align: sub
	}

	/*垂直对齐文本的下标 */
	.v-super {
		vertical-align: super
	}

	/* 	垂直对齐文本的上标 */
	.v-top {
		vertical-align: top
	}

	/* 把元素的顶端与行中最高元素的顶端对齐 */
	.v-text-top {
		vertical-align: text-top
	}

	/* 把元素的顶端与父元素字体的顶端对齐 */
	.v-middle {
		vertical-align: middle
	}

	/* 把此元素放置在父元素的中部 */
	.v-bottom {
		vertical-align: bottom
	}

	/* 把元素的顶端与行中最低的元素的顶端对齐 */
	.v-text-bottom {
		vertical-align: text-bottom
	}

	/* 把元素的底端与父元素字体的底端对齐 */
	/* flex横向 */
	.flex-auto {
		-webkit-box-flex: 1;
		-webkit-flex: auto;
		flex: auto
	}

	/* 即是:flex:1 1 auto;[第一个是放大值(默认为0，即如果存在剩余空间，也不放大),第二个是缩小值(默认为1，如果一个项目的flex-shrink属性为0，其他项目都为1，则空间不足时，前者不缩小),第三个固定值(跟width或height属性一样的值（比如350px），则项目将占据固定空间)] */
	.flex-none {
		-webkit-box-flex: 0;
		-webkit-flex: none;
		flex: none
	}

	/* 即是:flex:0 0 auto; */
	.flex-center {
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center
	}

	/* X轴(主轴)方向-所有元素居中(包括横向的和垂直方向的) */
	.flex-start {
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: start;
		-webkit-justify-content: flex-start;
		justify-content: flex-start
	}

	/* X轴(主轴)方向-所有元素居中(子元素-横向靠左对齐) */
	.flex-end {
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: end;
		-webkit-justify-content: flex-end;
		justify-content: flex-end
	}

	/* X轴(主轴)方向-所有元素垂直方向居中(子元素-横向靠右对齐)*/
	.flex-between {
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		justify-content: space-between
	}

	/* X轴(主轴)方向-所有元素垂直方向居中(两端对齐,子元素之间的间隔都相等。只有一个子元素时是左对齐)*/
	.flex-around {
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-justify-content: space-around;
		justify-content: space-around
	}

	/* X轴(主轴)方向-所有元素垂直方向居中(每个子元素两侧的间隔相等。所以，子元素之间的间隔比子元素与边框的间隔大一倍。只有一个子元素时是居中,)*/
	/* flex竖向flex-direction: column; */
	[class*="flex-col-"] {
		box-sizing: border-box;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		flex-direction: column
	}

	.flex-col-center {
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center
	}

	/* Y轴(主轴)方向-所有元素居中(包括横向的和垂直方向的都居中)*/
	.flex-col-start {
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: start;
		-webkit-align-items: flex-start;
		align-items: flex-start
	}

	/* Y轴(主轴)方向-所有元素垂直方向居中(子元素-横向靠左对齐)*/
	.flex-col-end {
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: end;
		-webkit-align-items: flex-end;
		align-items: flex-end
	}

	/* Y轴(主轴)方向-所有元素垂直方向居中(子元素-横向靠左对齐)*/
	.flex-col-baseline {
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: baseline;
		-webkit-align-items: baseline;
		align-items: baseline
	}

	/* Y轴(主轴)方向-所有元素垂直方向居中(X轴-项目的第一行文字的基线对齐)*/
	.flex-col-stretch {
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: stretch;
		-webkit-align-items: stretch;
		align-items: stretch
	}

	/* Y轴(主轴)方向-所有元素垂直方向居中(X轴-如果项目未设置高度或设为auto，将占满整个容器的高度)*/
	.flex-col-between {
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		-webkit-box-align: start;
		-webkit-align-items: flex-start;
		align-items: flex-start
	}

	/* Y轴(主轴)方向-所有元素垂直方向两端对齐(子元素-横向靠左对齐)*/
	.flex-col-around {
		-webkit-justify-content: space-around;
		justify-content: space-around;
		-webkit-box-align: start;
		-webkit-align-items: flex-start;
		align-items: flex-start
	}

	/* Y轴(主轴)方向-所有元素每个子元素上下之间的间隔相等(子元素-横向靠左对齐)*/
	/* grid网格布局 */
	.grid-column1 {
		display: grid;
		grid-template-columns: repeat(1, 1fr)
	}

	/* grid网格布局,1列,1*/
	.grid-column2 {
		display: grid;
		grid-template-columns: repeat(2, 1fr)
	}

	/* grid网格布局,2列,1:1*/
	.grid-column3 {
		display: grid;
		grid-template-columns: repeat(3, 1fr)
	}

	/* grid网格布局,3列,1:1:1*/
	.grid-column4 {
		display: grid;
		grid-template-columns: repeat(4, 1fr)
	}

	/* grid网格布局,4列,1:1:1:1*/
	.grid-column5 {
		display: grid;
		grid-template-columns: repeat(5, 1fr)
	}

	/* grid网格布局,5列,1:1:1:1:1*/
	.grid-column6 {
		display: grid;
		grid-template-columns: repeat(6, 1fr)
	}

	/* grid网格布局,6列,1:1:1:1:1:1*/
	.grid-c-20 {
		grid-column-gap: 10px
	}

	/*每列之间的间距 */
	.grid-r-20 {
		grid-row-gap: 10px
	}

	/*每行之间的间距  */
	.grid-rc-20 {
		grid-column-gap: 10px;
		grid-row-gap: 10px
	}

	/*每行及每列之间的间距  */
	.grid-gap10p {
		grid-gap: 10px
	}

	/*每行及每列之间的间距  */
	.grid-gap20 {
		grid-gap: 10px
	}

	/*每行及每列之间的间距  */
	/* 浮动 与flex不兼容*/
	.float-left {
		float: left
	}

	.float-right {
		float: right
	}

	/* Border */
	.border {
		border: 1px solid var(--bordercolor)
	}

	/* 四边框有波打线-2rpx宽/--bordercolor色 */
	.border-top {
		border-top: 1px solid var(--bordercolor)
	}

	/* 上边框波打线-2rpx宽、--bordercolor色 */
	.border-right {
		border-right: 1px solid var(--bordercolor)
	}

	/* 右边框波打线-2rpx宽、--bordercolor色 */
	.border-bottom {
		border-bottom: 1px solid var(--bordercolor)
	}

	/* 下边框波打线-2rpx宽、--bordercolor色 */
	.border-left {
		border-left: 1px solid var(--bordercolor)
	}

	/* 左边框波打线-2rpx宽、--bordercolor色 */
	/* 新增 */
	.border-top-20bg {
		border-top: 10px solid var(--backgroundcolor)
	}

	/* 上边框波打线-20rpx宽、背景色 */
	.border-bottom-20bg {
		border-bottom: 10px solid var(--backgroundcolor)
	}

	/* 下边框波打线-20rpx宽、背景色 */
	.border-main {
		border: 1px solid var(--themescolor)
	}

	/* 四边框波打线-2rpx宽、主题颜色 */
	.border-t-main {
		border-top: 1px solid var(--themescolor)
	}

	/* 上边框波打线-2rpx宽、主题颜色 */
	.border-r-main {
		border-right: 1px solid var(--themescolor)
	}

	/* 右边框波打线-2rpx宽、主题颜色 */
	.border-b-main {
		border-bottom: 1px solid var(--themescolor)
	}

	/* 下边框波打线-2rpx宽、主题颜色 */
	.border-l-main {
		border-left: 1px solid var(--themescolor)
	}

	/* 左边框波打线-2rpx宽、主题颜色 */
	.border-0 {
		border-width: 0
	}

	.border-top-0 {
		border-top-width: 0
	}

	.border-right-0 {
		border-right-width: 0
	}

	.border-bottom-0 {
		border-bottom-width: 0
	}

	.border-left-0 {
		border-left-width: 0
	}

	.border-primary {
		border-color: var(--primary) !important
	}

	.border-secondary {
		border-color: var(--secondary) !important
	}

	.border-success {
		border-color: var(--success) !important
	}

	.border-danger {
		border-color: var(--danger) !important
	}

	.border-warning {
		border-color: var(--warning) !important
	}

	.border-info {
		border-color: var(--info) !important
	}

	.border-light {
		border-color: var(--light) !important
	}

	.border-dark {
		border-color: var(--dark) !important
	}

	.border-white {
		border-color: var(--white) !important
	}

	.border-light-secondary {
		border-color: #f1f1f1 !important
	}

	.border-c-main {
		border-color: var(--themescolor) !important
	}

	/* 新增 */
	.border-themescolor {
		border-color: var(--themescolor) !important
	}

	.rounded {
		border-radius: 2px
	}

	.rounded-circle {
		border-radius: 100%
	}

	.rounded-0 {
		border-radius: 0
	}

	/* 新增 */
	.rounded-5 {
		border-radius: 2px
	}

	.rounded-8 {
		border-radius: 4px
	}

	.rounded-10 {
		border-radius: 5px
	}

	.rounded-20 {
		border-radius: 10px
	}

	.rounded-22 {
		border-radius: 11px
	}

	.rounded-30 {
		border-radius: 15px
	}

	.rounded-50 {
		border-radius: 25px
	}

	.rounded-100 {
		border-radius: 50px
	}

	/* color */
	.text-primary {
		color: var(--primary) !important
	}

	.text-secondary {
		color: var(--secondary) !important
	}

	.text-success {
		color: var(--success) !important
	}

	.text-danger {
		color: var(--danger) !important
	}

	.text-warning {
		color: var(--warning) !important
	}

	.text-info {
		color: var(--info) !important
	}

	.text-light {
		color: var(--light) !important
	}

	.text-dark {
		color: var(--dark) !important
	}

	.text-muted {
		color: var(--muted) !important
	}

	.text-light-muted {
		color: var(--lightmuted) !important
	}

	.text-white {
		color: var(--white) !important
	}

	/* 新增的灰色 */
	.text-333 {
		color: #333 !important
	}

	.text-555 {
		color: #555 !important
	}

	.text-666 {
		color: #666 !important
	}

	.text-999 {
		color: #999 !important
	}

	.text-bbb {
		color: #bbb !important
	}

	.text-ccc {
		color: #ccc !important
	}

	.text-ddd {
		color: #ddd !important
	}

	.text-eee {
		color: #eee !important
	}

	.text-fff {
		color: #fff !important
	}

	.text-main {
		color: var(--themescolor) !important
	}

	.bg-primary {
		background-color: var(--primary) !important
	}

	.bg-secondary {
		background-color: var(--secondary) !important
	}

	.bg-success {
		background-color: var(--success) !important
	}

	.bg-danger {
		background-color: var(--danger) !important
	}

	.bg-warning {
		background-color: var(--warning) !important
	}

	.bg-info {
		background-color: var(--info) !important
	}

	.bg-light {
		background-color: var(--light) !important
	}

	.bg-dark {
		background-color: var(--dark) !important
	}

	.bg-white {
		background-color: var(--white) !important
	}

	.bg-light-secondary {
		background-color: #f1f1f1 !important
	}

	/* 新增 */
	.bg-bg {
		background-color: var(--backgroundcolor) !important
	}

	.bg-333 {
		background-color: #333 !important
	}

	.bg-555 {
		background-color: #555 !important
	}

	.bg-666 {
		background-color: #666 !important
	}

	.bg-999 {
		background-color: #999 !important
	}

	.bg-aaa {
		background-color: #aaa !important
	}

	.bg-bbb {
		background-color: #bbb !important
	}

	.bg-ccc {
		background-color: #ccc !important
	}

	.bg-ddd {
		background-color: #ddd !important
	}

	.bg-eee {
		background-color: #eee !important
	}

	.bg-fff {
		background-color: #fff !important
	}

	.bg-main {
		background-color: var(--themescolor) !important
	}

	.bg-transparent {
		background: transparent !important
	}

	/* 透明度 */
	.opacity-0 {
		opacity: 0
	}

	.opacity-2 {
		opacity: .2
	}

	.opacity-4 {
		opacity: .4
	}

	.opacity-6 {
		opacity: .6
	}

	.opacity-8 {
		opacity: .8
	}

	.opacity-10 {
		opacity: 1
	}

	/* Spacing */
	.m-0 {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		margin-bottom: 0
	}

	.m {
		margin-left: 2px;
		margin-right: 2px;
		margin-top: 2px;
		margin-bottom: 2px
	}

	.m-1 {
		margin-left: 5px;
		margin-right: 5px;
		margin-top: 5px;
		margin-bottom: 5px
	}

	.m-2 {
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 10px;
		margin-bottom: 10px
	}

	.m-3 {
		margin-left: 15px;
		margin-right: 15px;
		margin-top: 15px;
		margin-bottom: 15px
	}

	.m-4 {
		margin-left: 20px;
		margin-right: 20px;
		margin-top: 20px;
		margin-bottom: 20px
	}

	.m-5 {
		margin-left: 25px;
		margin-right: 25px;
		margin-top: 25px;
		margin-bottom: 25px
	}

	.m-6 {
		margin-left: 30px;
		margin-right: 30px;
		margin-top: 30px;
		margin-bottom: 30px
	}

	.m-8 {
		margin-left: 40px;
		margin-right: 40px;
		margin-top: 40px;
		margin-bottom: 40px
	}

	.m-10 {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 50px;
		margin-bottom: 50px
	}

	.m-12 {
		margin-left: 60px;
		margin-right: 60px;
		margin-top: 60px;
		margin-bottom: 60px
	}

	/* 新增 */
	.m-auto {
		margin: auto
	}

	.mx-0 {
		margin-left: 0;
		margin-right: 0
	}

	.mx {
		margin-left: 2px;
		margin-right: 2px
	}

	.mx-1 {
		margin-left: 5px;
		margin-right: 5px
	}

	.mx-2 {
		margin-left: 10px;
		margin-right: 10px
	}

	.mx-3 {
		margin-left: 15px;
		margin-right: 15px
	}

	.mx-4 {
		margin-left: 20px;
		margin-right: 20px
	}

	.mx-5 {
		margin-left: 25px;
		margin-right: 25px
	}

	.mx-6 {
		margin-left: 30px;
		margin-right: 30px
	}

	.mx-8 {
		margin-left: 40px;
		margin-right: 40px
	}

	.mx-10 {
		margin-left: 50px;
		margin-right: 50px
	}

	.mx-12 {
		margin-left: 60px;
		margin-right: 60px
	}

	.my-0 {
		margin-top: 0;
		margin-bottom: 0
	}

	.my {
		margin-top: 2px;
		margin-bottom: 2px
	}

	.my-1 {
		margin-top: 5px;
		margin-bottom: 5px
	}

	.my-2 {
		margin-top: 10px;
		margin-bottom: 10px
	}

	.my-3 {
		margin-top: 15px;
		margin-bottom: 15px
	}

	.my-4 {
		margin-top: 20px;
		margin-bottom: 20px
	}

	.my-5 {
		margin-top: 25px;
		margin-bottom: 25px
	}

	.my-6 {
		margin-top: 30px;
		margin-bottom: 30px
	}

	.my-8 {
		margin-top: 40px;
		margin-bottom: 40px
	}

	.my-10 {
		margin-top: 50px;
		margin-bottom: 50px
	}

	.my-12 {
		margin-top: 60px;
		margin-bottom: 60px
	}

	.mt-0 {
		margin-top: 0
	}

	.mt {
		margin-top: 2px
	}

	.mt-auto {
		margin-top: auto
	}

	.mt-1 {
		margin-top: 5px
	}

	.mt-2 {
		margin-top: 10px
	}

	.mt-3 {
		margin-top: 15px
	}

	.mt-4 {
		margin-top: 20px
	}

	.mt-5 {
		margin-top: 25px
	}

	.mt-6 {
		margin-top: 30px
	}

	.mt-8 {
		margin-top: 40px
	}

	.mt-10 {
		margin-top: 50px
	}

	.mt-12 {
		margin-top: 60px
	}

	.mb-0 {
		margin-bottom: 0
	}

	.mb {
		margin-bottom: 2px
	}

	.mb-auto {
		margin-bottom: auto
	}

	.mb-1 {
		margin-bottom: 5px
	}

	.mb-2 {
		margin-bottom: 10px
	}

	.mb-3 {
		margin-bottom: 15px
	}

	.mb-4 {
		margin-bottom: 20px
	}

	.mb-5 {
		margin-bottom: 25px
	}

	.mb-6 {
		margin-bottom: 30px
	}

	.mb-8 {
		margin-bottom: 40px
	}

	.mb-10 {
		margin-bottom: 50px
	}

	.mb-12 {
		margin-bottom: 60px
	}

	.ml-0 {
		margin-left: 0
	}

	.ml {
		margin-left: 2px
	}

	.ml-auto {
		margin-left: auto
	}

	.ml-1 {
		margin-left: 5px
	}

	.ml-2 {
		margin-left: 10px
	}

	.ml-3 {
		margin-left: 15px
	}

	.ml-4 {
		margin-left: 20px
	}

	.ml-5 {
		margin-left: 25px
	}

	.ml-6 {
		margin-left: 30px
	}

	.ml-8 {
		margin-left: 40px
	}

	.ml-10 {
		margin-left: 50px
	}

	.ml-12 {
		margin-left: 60px
	}

	.mr-0 {
		margin-right: 0
	}

	.mr {
		margin-right: 2px
	}

	.mr-auto {
		margin-right: auto
	}

	.mr-1 {
		margin-right: 5px
	}

	.mr-2 {
		margin-right: 10px
	}

	.mr-3 {
		margin-right: 15px
	}

	.mr-4 {
		margin-right: 20px
	}

	.mr-5 {
		margin-right: 25px
	}

	.mr-6 {
		margin-right: 30px
	}

	.mr-8 {
		margin-right: 40px
	}

	.mr-10 {
		margin-right: 50px
	}

	.mr-12 {
		margin-right: 60px
	}

	.p-0 {
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
		padding-bottom: 0
	}

	.p {
		padding-left: 2px;
		padding-right: 2px;
		padding-top: 2px;
		padding-bottom: 2px
	}

	.p-1 {
		padding-left: 5px;
		padding-right: 5px;
		padding-top: 5px;
		padding-bottom: 5px
	}

	.p-2 {
		padding-left: 10px;
		padding-right: 10px;
		padding-top: 10px;
		padding-bottom: 10px
	}

	.p-3 {
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 15px;
		padding-bottom: 15px
	}

	.p-4 {
		padding-left: 20px;
		padding-right: 20px;
		padding-top: 20px;
		padding-bottom: 20px
	}

	.p-5 {
		padding-left: 25px;
		padding-right: 25px;
		padding-top: 25px;
		padding-bottom: 25px
	}

	.px-0 {
		padding-left: 0;
		padding-right: 0
	}

	.px {
		padding-left: 2px;
		padding-right: 2px
	}

	.px-1 {
		padding-left: 5px;
		padding-right: 5px
	}

	.px-2 {
		padding-left: 10px;
		padding-right: 10px
	}

	.px-3 {
		padding-left: 15px;
		padding-right: 15px
	}

	.px-4 {
		padding-left: 20px;
		padding-right: 20px
	}

	.px-5 {
		padding-left: 25px;
		padding-right: 25px
	}

	.px-6 {
		padding-left: 30px;
		padding-right: 30px
	}

	.px-8 {
		padding-left: 40px;
		padding-right: 40px
	}

	.px-10 {
		padding-left: 50px;
		padding-right: 50px
	}

	.px-12 {
		padding-left: 60px;
		padding-right: 60px
	}

	.py-0 {
		padding-top: 0;
		padding-bottom: 0
	}

	.py {
		padding-top: 2px;
		padding-bottom: 2px
	}

	.py-1 {
		padding-top: 5px;
		padding-bottom: 5px
	}

	.py-2 {
		padding-top: 10px;
		padding-bottom: 10px
	}

	.py-3 {
		padding-top: 15px;
		padding-bottom: 15px
	}

	.py-4 {
		padding-top: 20px;
		padding-bottom: 20px
	}

	.py-5 {
		padding-top: 25px;
		padding-bottom: 25px
	}

	.py-6 {
		padding-top: 30px;
		padding-bottom: 30px
	}

	.py-8 {
		padding-top: 40px;
		padding-bottom: 40px
	}

	.py-10 {
		padding-top: 50px;
		padding-bottom: 50px
	}

	.py-12 {
		padding-top: 60px;
		padding-bottom: 60px
	}

	.pt-0 {
		padding-top: 0
	}

	.pt {
		padding-top: 2px
	}

	.pt-1 {
		padding-top: 5px
	}

	.pt-2 {
		padding-top: 10px
	}

	.pt-3 {
		padding-top: 15px
	}

	.pt-4 {
		padding-top: 20px
	}

	.pt-5 {
		padding-top: 25px
	}

	.pt-6 {
		padding-top: 30px
	}

	.pt-8 {
		padding-top: 40px
	}

	.pt-10 {
		padding-top: 50px
	}

	.pt-12 {
		padding-top: 60px
	}

	.pt-44p {
		padding-top: 44px
	}

	.pb-0 {
		padding-bottom: 0
	}

	.pb {
		padding-bottom: 2px
	}

	.pb-1 {
		padding-bottom: 5px
	}

	.pb-2 {
		padding-bottom: 10px
	}

	.pb-3 {
		padding-bottom: 15px
	}

	.pb-4 {
		padding-bottom: 20px
	}

	.pb-5 {
		padding-bottom: 25px
	}

	.pb-6 {
		padding-bottom: 30px
	}

	.pb-8 {
		padding-bottom: 40px
	}

	.pb-10 {
		padding-bottom: 50px
	}

	.pb-12 {
		padding-bottom: 60px
	}

	.pl-0 {
		padding-left: 0
	}

	.pl {
		padding-left: 2px
	}

	.pl-1 {
		padding-left: 5px
	}

	.pl-2 {
		padding-left: 10px
	}

	.pl-3 {
		padding-left: 15px
	}

	.pl-4 {
		padding-left: 20px
	}

	.pl-5 {
		padding-left: 25px
	}

	.pl-6 {
		padding-left: 30px
	}

	.pl-8 {
		padding-left: 40px
	}

	.pl-10 {
		padding-left: 50px
	}

	.pl-12 {
		padding-left: 60px
	}

	.pr-0 {
		padding-right: 0
	}

	.pr {
		padding-right: 2px
	}

	.pr-1 {
		padding-right: 5px
	}

	.pr-2 {
		padding-right: 10px
	}

	.pr-3 {
		padding-right: 15px
	}

	.pr-4 {
		padding-right: 20px
	}

	.pr-5 {
		padding-right: 25px
	}

	.pr-6 {
		padding-right: 30px
	}

	.pr-8 {
		padding-right: 40px
	}

	.pr-10 {
		padding-right: 50px
	}

	.pr-12 {
		padding-right: 60px
	}

	/* 新增 */
	.zindex-1 {
		z-index: 1 !important
	}

	.zindex-2 {
		z-index: 2 !important
	}

	.zindex-99 {
		z-index: 99 !important
	}

	.zindex-109 {
		z-index: 109 !important
	}

	.zindex-9999 {
		z-index: 9999 !important
	}

	/* 新增 */
	.overflow-h {
		overflow: hidden
	}

	.overflow-x {
		overflow-x: auto
	}

	.overflow-x-h {
		overflow-x: hidden
	}

	.overflow-x-scroll {
		overflow-x: scroll
	}

	.overflow-y {
		overflow-y: auto
	}

	.overflow-y-h {
		overflow-y: hidden
	}

	.overflow-y-scroll {
		overflow-y: scroll
	}

	.overflow-scroll {
		overflow: scroll
	}

	.overflow-auto {
		overflow: auto
	}

	.overflow-visible {
		overflow: visible
	}

	/* 防文字溢出*/
	[class*="line-clamp"] {
		text-overflow: ellipsis;
		overflow: hidden
	}

	.line-clamp1 {
		display: inline-block;
		width: 100%;
		white-space: nowrap
	}

	/* 作用：限制只显示1行,超出部分以...显示,备注:不能用-webkit-line-clamp:1(因为这样当出现...时行距会发生变化) */
	.line-clamp2 {
		display: -webkit-inline-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-wrap: break-word;
		word-break: break-all
	}

	/* 作用：限制只显示2行,超出部分以...显示*/
	.line-clamp3 {
		display: -webkit-inline-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		word-wrap: break-word;
		word-break: break-all
	}

	/* 作用：限制只显示3行,超出部分以...显示*/
	.line-clamp4 {
		display: -webkit-inline-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		word-wrap: break-word;
		word-break: break-all
	}

	/* 限制只显示4行,超出部分以...显示 */
	.line-clamp5 {
		display: -webkit-inline-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		word-wrap: break-word;
		word-break: break-all
	}

	/* 限制只显示5行,超出部分以...显示 */
	/* 在父组件不是flex布局的情况下●子●元素水平居(屏幕)中--备注:父组件必须是class="position-relative"或者父组件是body*/
	.center-x {
		position: absolute;
		left: 50%;
		-webkit-transform: translate(-50%);
		transform: translate(-50%)
	}

	/* 在父组件不是flex布局的情况下●子●元素垂直居(屏幕)中--备注:父组件必须是class="position-relative"或者父组件是body*/
	.center-y {
		position: absolute;
		top: 50%;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%)
	}

	/* 在父组件不是flex布局的情况下●子●元素水平及垂直居(屏幕)中--备注:父组件必须是class="position-relative"或者父组件是body */
	.center-xy {
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%)
	}

	/* 线性渐变 */
	.l-gradient-l {
		background-image: -webkit-linear-gradient(left, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(90deg, var(--themescolor), var(--themesrgba02))
	}

	/* 从左到右线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-lt {
		background-image: -webkit-linear-gradient(left top, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(to right bottom, var(--themescolor), var(--themesrgba02))
	}

	/* 从左上到右下线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-lb {
		background-image: -webkit-linear-gradient(left bottom, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(to right top, var(--themescolor), var(--themesrgba02))
	}

	/* 从左下到右上线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-r {
		background-image: -webkit-linear-gradient(right, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(270deg, var(--themescolor), var(--themesrgba02))
	}

	/* 从右到左线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-rt {
		background-image: -webkit-linear-gradient(right top, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(to left bottom, var(--themescolor), var(--themesrgba02))
	}

	/* 从右上到左下线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-rb {
		background-image: -webkit-linear-gradient(right bottom, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(to left top, var(--themescolor), var(--themesrgba02))
	}

	/* 从右下到左上线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-t {
		background-image: -webkit-linear-gradient(top, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(180deg, var(--themescolor), var(--themesrgba02))
	}

	/* 从上到下线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-b {
		background-image: -webkit-linear-gradient(bottom, var(--themescolor), var(--themesrgba02));
		background-image: linear-gradient(0deg, var(--themescolor), var(--themesrgba02))
	}

	/* 从下到上线性主题色渐变,从1透明度过渡到0.2透明度 */
	.l-gradient-l1007 {
		background-image: -webkit-linear-gradient(left, var(--themescolor), var(--themesrgba07));
		background-image: linear-gradient(90deg, var(--themescolor), var(--themesrgba07))
	}

	/* 从左到右线性主题色渐变,从1透明度过渡到0.7透明度 */
	.l-gradient-l1005 {
		background-image: -webkit-linear-gradient(left, var(--themescolor), var(--themesrgba05));
		background-image: linear-gradient(90deg, var(--themescolor), var(--themesrgba05))
	}

	/* 从左到右线性主题色渐变,从1透明度过渡到0.5透明度 */
	/* 径向渐变 */
	.r-gradient-1002 {
		background-image: Radial-gradient(ellipse, var(--themescolor), var(--themesrgba02))
	}

	/* 从中心向外发散椭圆形(默认值是ellipse椭圆形)径向主题色渐变,从1透明度变成0.2透明度 */
	.r-gradient-0210 {
		background-image: Radial-gradient(ellipse, var(--themesrgba02), var(--themescolor))
	}

	/* 从中心向外发散椭圆形(默认值是ellipse椭圆形)径向主题色渐变,从0.2透明度变成1透明度 */
	.r-gradient-c1002 {
		background-image: Radial-gradient(circle, var(--themescolor), var(--themesrgba02))
	}

	/* 从中心向外发散圆心径向主题色渐变,从1透明度变成0.2透明度 */
	.r-gradient-c0210 {
		background-image: Radial-gradient(circle, var(--themesrgba02), var(--themescolor))
	}

	/* 从中心向外发散圆心径向主题色渐变,从0.2透明度变成1透明度 */
	/* 动画 */
	.translate3d0 {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}

	/* position:fiexd;时的防抖 */
	.translateX120 {
		-webkit-transition: all 1.5s;
		transition: all 1.5s;
		-webkit-transform: translateX(120%);
		transform: translateX(120%)
	}

	.translateX150 {
		-webkit-transition: all 1.5s;
		transition: all 1.5s;
		-webkit-transform: translateX(150%);
		transform: translateX(150%)
	}

	.translateX0 {
		-webkit-transition: all 1.5s;
		transition: all 1.5s;
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}

	.transition-all05 {
		-webkit-transition: all .5s;
		transition: all .5s
	}

	.transition-all10 {
		-webkit-transition: all 1s;
		transition: all 1s
	}

	.transition-all15 {
		-webkit-transition: all 1.5s;
		transition: all 1.5s
	}

	.zoom-out0002 {
		-webkit-animation: zoom-out0005 .2s linear;
		animation: zoom-out0005 .2s linear
	}

	@-webkit-keyframes zoom-out0005 {
		0% {
			-webkit-transform: scale(0);
			transform: scale(0)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 缩小从0放大到1，动画时间0.2秒 */
	.zoom-out0005 {
		-webkit-animation: zoom-out0005 .5s linear;
		animation: zoom-out0005 .5s linear
	}

	@keyframes zoom-out0005 {
		0% {
			-webkit-transform: scale(0);
			transform: scale(0)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 缩小从0放大到1，动画时间0.5秒 */
	.zoom-out0010 {
		-webkit-animation: zoom-out0010 1s linear;
		animation: zoom-out0010 1s linear
	}

	@-webkit-keyframes zoom-out0010 {
		0% {
			-webkit-transform: scale(0);
			transform: scale(0)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-out0010 {
		0% {
			-webkit-transform: scale(0);
			transform: scale(0)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 缩小从0放大到1，动画时间1秒 */
	.zoom-out0910 {
		-webkit-animation: zoom-out0910 1s linear;
		animation: zoom-out0910 1s linear
	}

	@-webkit-keyframes zoom-out0910 {
		0% {
			-webkit-transform: scale(.9);
			transform: scale(.9)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-out0910 {
		0% {
			-webkit-transform: scale(.9);
			transform: scale(.9)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 缩小从0.9放大到1，动画时间1秒 */
	.zoom-in1110 {
		-webkit-animation: zoom-in1110 1s linear;
		animation: zoom-in1110 1s linear
	}

	@-webkit-keyframes zoom-in1110 {
		0% {
			-webkit-transform: scale(1.1);
			transform: scale(1.1)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in1110 {
		0% {
			-webkit-transform: scale(1.1);
			transform: scale(1.1)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 缩小从1.1缩小到1，动画时间1秒 */
	.zoom-in-out0910 {
		-webkit-animation: zoom-in-out0910 1s linear;
		animation: zoom-in-out0910 1s linear
	}

	@-webkit-keyframes zoom-in-out0910 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(.9);
			transform: scale(.9)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in-out0910 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(.9);
			transform: scale(.9)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 缩小0.9倍后再还原，动画时间1秒 */
	.zoom-in-out1110 {
		-webkit-animation: zoom-in-out1110 1s linear;
		animation: zoom-in-out1110 1s linear
	}

	@-webkit-keyframes zoom-in-out1110 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.1);
			transform: scale(1.1)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in-out1110 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.1);
			transform: scale(1.1)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 放大1.1倍后再还原，动画时间1秒 */
	.zoom-in-out1210 {
		-webkit-animation: zoom-in-out1210 1s linear;
		animation: zoom-in-out1210 1s linear
	}

	@-webkit-keyframes zoom-in-out1210 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.2);
			transform: scale(1.2)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in-out1210 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.2);
			transform: scale(1.2)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 放大1.2倍后再还原，动画时间1秒 */
	.zoom-in-out1215 {
		-webkit-animation: zoom-in-out1215 1.5s linear;
		animation: zoom-in-out1215 1.5s linear
	}

	@-webkit-keyframes zoom-in-out1215 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.2);
			transform: scale(1.2)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in-out1215 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.2);
			transform: scale(1.2)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 放大1.2倍后再还原，动画时间1.5秒 */
	.zoom-in-out1510 {
		-webkit-animation: zoom-in-out1510 1s linear;
		animation: zoom-in-out1510 1s linear
	}

	@-webkit-keyframes zoom-in-out1510 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.5);
			transform: scale(1.5)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in-out1510 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(1.5);
			transform: scale(1.5)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 放大1.5倍后再还原，动画时间1秒 */
	.zoom-in-out2010 {
		-webkit-animation: zoom-in-out2010 1s linear;
		animation: zoom-in-out2010 1s linear
	}

	@-webkit-keyframes zoom-in-out2010 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(2);
			transform: scale(2)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	@keyframes zoom-in-out2010 {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		50% {
			-webkit-transform: scale(2);
			transform: scale(2)
		}

		100% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}

	/* 放大2倍后再还原，动画时间1秒 */
	/* 辅助 */
	[class*="mask-percent"] {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		background: rgba(0, 0, 0, .65);
		z-index: 999
	}

	.mask-percent-s {
		top: 0
	}

	/* popup等插件要用到的黑色透明容器(子元素能设定高度百分比,但只能放在HTML的最外层父级元素里),show时的状态(top: 0;)*/
	.mask-percent-h {
		top: 100%
	}

	/* popup hidden时的状态(top: 100%;)*/
	[class*="mask-wrapper"] {
		position: fixed;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0, 0, 0, .4);
		z-index: 999
	}

	.mask-wrapper-s {
		top: 0
	}

	/* popup等插件要用到的黑色透明容器(子元素不能设定高度百分比,只能用rem或rpx来定义子元素的高度,但可以放在HTML任意层级元素里),show时的状态(top: 0;) */
	.mask-wrapper-h {
		top: 100%
	}

	/* popup hidden时的状态(top: 100%;)*/
	.bg-cover {
		background-size: cover;
		background-repeat: no-repeat;
		background-position: 50%
	}

	/* 背景图自适应(拉伸-图像完全覆盖背景区域) */
	.bg-cover-all {
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: 50%
	}

	/* 背景图自适应(平铺) */
	/*每个页面公共css */
	body,
	div,
	ul,
	li,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	dl,
	dt,
	dd,
	ol,
	uni-form,
	uni-input,
	uni-textarea,
	th,
	td,
	select {
		margin: 0;
		padding: 0
	}

	html {
		-webkit-text-size-adjust: 100%
	}

	html,
	body {
		height: 100%
	}

	a,
	div,
	header,
	span,
	uni-text {
		-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
		outline: none
	}

	body,
	uni-button,
	uni-input,
	keygen,
	legend,
	select,
	uni-textarea {
		font-family: Microsoft YaHei, Arial, Helvetica, sans-serif;
		color: #333;
		outline: none;
		box-shadow: none
	}

	uni-button {
		cursor: pointer
	}

	table {
		border-collapse: collapse;
		border-spacing: 0
	}

	em,
	i {
		color: #333;
		font-style: normal
	}

	img {
		border: 0;
		margin: 0;
		padding: 0;
		vertical-align: initial
	}

	li,
	ol,
	ul {
		list-style: none
	}

	a {
		color: #333;
		text-decoration: none
	}

	uni-input[type="button"] {
		cursor: pointer
	}

	uni-textarea {
		resize: none;
		overflow: auto
	}

	uni-input::-webkit-input-placeholder,
	uni-textarea::-webkit-input-placeholder {
		color: #999
	}

	uni-input:-moz-placeholder,
	uni-textarea:-moz-placeholder {
		color: #999
	}

	uni-input::-moz-placeholder,
	uni-textarea::-moz-placeholder {
		color: #999
	}

	uni-input:-ms-input-placeholder,
	uni-textarea:-ms-input-placeholder {
		color: #999
	}

	uni-input:-webkit-autofill {
		box-shadow: 0 0 0 1000px #fff inset !important
	}

	uni-input,
	uni-textarea {
		-webkit-user-select: auto;
		user-select: auto
	}

	.white-bg {
		background: #fff
	}

	.gray-body {
		background: #f6f7f8
	}

	.w750 {
		max-width: 750px;
		margin: 0 auto;
		width: 100%;
		/* height: 100%; */
		min-height: 100%;
		min-width: 320px;
		/* position: relative; */
		padding-bottom: var(--safe-area-inset-bottom)
			/* padding-top: var(--safe-area-inset-top); */
	}

	/* .clearfix {
   *zoom: 1;
 } */
	.clearfix:after {
		content: " ";
		display: table;
		clear: both
	}

	.mt10 {
		margin-top: 10px
	}

	.mb10 {
		margin-bottom: 10px
	}

	.price {
		display: inline-block;
		font-family: arial
	}

	.old-price {
		margin-left: 3px;
		color: #999;
		text-decoration: line-through;
		font-size: 12px
	}

	/* end 通用样式 */
	/* 头部 */
	.header {
		width: 100%;
		max-width: 750px;
		position: fixed;
		z-index: 100;
		background: transparent;
		border: 0;
		top: 0;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}

	.unable {
		color: #e4e4e4 !important;
		border: 1px solid #ccc !important
	}

	.header+div {
		margin-top: 44px
	}

	.header .header-box {
		height: 44px;
		background: #fff;
		position: relative;
		display: -webkit-flex;
		display: -webkit-box;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .07);
		width: 100%
	}

	.header .header-box.opacity {
		background: transparent !important
	}

	.header .header-box .header-back {
		height: 30px;
		margin: 7px 0 7px 10px;
		border-radius: 30px
	}

	.header .header-box .header-back .back-img {
		display: block;
		font-size: 0;
		min-width: 20px;
		text-align: left;
		cursor: pointer
	}

	.header .header-box .header-back .back-img img {
		width: 20px;
		height: 20px;
		vertical-align: top;
		margin-top: 5px
	}

	.header .header-box .header-search {
		position: relative;
		height: 30px;
		-webkit-flex: 1;
		-ms-flex: 1;
		-webkit-box-flex: 1;
		-moz-box-flex: 1;
		flex: 1;
		margin: 7px 10px;
		width: 100%
	}

	.header .header-box .header-search .ser-txt {
		text-align: center;
		font-size: 16px;
		line-height: 30px
	}

	.header .header-box .header-search .ser-input {
		width: 100%;
		height: 30px;
		border-radius: 50px;
		border: 0;
		padding: 0 15px 0 32px;
		line-height: 30px;
		vertical-align: top;
		background: #f7f7f7;
		font-size: 14px;
		color: #bbb;
		box-sizing: border-box
	}

	.header .header-box .header-search .ser-i {
		position: absolute;
		left: 10px;
		top: 7px;
		display: block;
		width: 16px;
		height: 16px;
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAANlBMVEUAAADMzMzPz8/Nzc3Pz8/MzMzMzMzMzMzMzMzNzc3Pz8/MzMzMzMzMzMzNzc3MzMzMzMzMzMzyvbXuAAAAEXRSTlMAQBBgIODQwLBwMPCgkH+fUP9q/k0AAADJSURBVDjLlZJRtsIgDESBEJJQrG/2v9lnj5UqjaLz1Z5cMiFM+EWZVJhFKbvlKuiSeq5fAIjFm2wjL0M5FaDl7tWAkob6Ul/8lldCwXkYmKHHH+3nhx7UDfj4fj7FDxMDB0cM6xOYBxB0dwCyu1jg7hFRgquCuAPiA7ID9B6waYfpDLNbfN6DQWebpOMtzGvAafKaf5M8yJCo+FyPyzlzuB6ZvAKcnFSXNd60Fmyi014aurSSQ4REKqVIs81rHYiz2jdEnRCawlz/Hw8KKhta5TQAAAAASUVORK5CYII=) no-repeat;
		background-size: 16px 16px
	}

	.header .header-box .header-mes {
		margin: 7px 10px 7px 0;
		height: 30px;
		line-height: 28px;
		width: 30px;
		/* min-width: 20px; */
		text-align: right
	}

	.header .header-box .header-mes .mes-img {
		display: block;
		/* font-size: 0; */
		min-width: 20px;
		cursor: pointer
	}

	.header .header-box .header-mes .mes-img img {
		width: 20px;
		height: 20px;
		vertical-align: top;
		margin-top: 5px
	}

	.header .header-box .header-mes .mes-txt {
		font-size: 14px;
		color: #666;
		cursor: pointer
	}

	/* end 头部 */
	/* 头部下拉菜单 */
	.head-select {
		position: fixed;
		/* top: 51px; */
		/* right: 10px; */
		/* z-index: 110; */
		border-radius: 4px;
		width: 125px;
		background: rgba(0, 0, 0, .85)
			/* display: none; */
	}

	.head-select:before {
		position: absolute;
		top: -12px;


		right: 7px;
		width: 0;
		height: 0;
		content: "";
		border: 6px solid transparent;
		border-bottom: 6px solid rgba(0, 0, 0, .85)
	}

	.head-select .sel-p {
		display: block;
		position: relative;
		margin-left: 40px;
		border-bottom: 1px solid hsla(0, 0%, 100%, .2);
		height: 40px;
		line-height: 40px;
		z-index: 100;
		margin-right: 10px
	}

	.head-select .sel-p:last-child {
		border: 0
	}

	.head-select .sel-p .item-img {
		position: absolute;
		top: 0;
		left: -40px;
		width: 40px;
		height: 40px;
		font-size: 0;
		text-align: center
	}

	.head-select .sel-p .item-img img {
		width: 15px;
		vertical-align: top;
		margin-top: 13px
	}

	.head-select .sel-p .item-img .img {
		width: 15px;
		height: 15px;
		vertical-align: top;
		margin-top: 13px
	}

	.head-select .sel-p .item-txt {
		display: block;
		border: 0;
		width: 100%;
		font-size: 14px;
		color: #fff;
		text-decoration: none;
		text-align: left
	}

	/* end 头部下拉菜单 */
	/* 导航 */
	.m-tabs {
		height: 44px;
		line-height: 44px;
		box-sizing: border-box;
		background: #fff;
		text-align: center;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		border-bottom: 1px solid #f6f7f8
	}

	.m-tabs .item {
		display: block;
		-webkit-flex: 1;
		-ms-flex: 1;
		-webkit-box-flex: 1;
		-moz-box-flex: 1;
		flex: 1;
		cursor: pointer
	}

	.m-tabs .item .txt {
		display: inline-block;
		padding: 0 10px;
		font-size: 14px;
		line-height: 42px;
		position: relative;
		white-space: nowrap
	}

	.m-tabs .item.on .txt {
		color: var(--themescolor)
	}

	.m-tabs .item.line-on .txt {
		color: var(--themescolor);
		line-height: 38px;
		border-bottom: 2px solid var(--themescolor)
	}

	.m-tabs .item.arrow .txt {
		padding: 0 19px 0 6px
	}

	.m-tabs .item.arrow .txt::after {
		content: " ";
		display: block;
		width: 0;
		height: 0;
		position: absolute;
		right: 6px;
		top: 20px;
		border: 4px solid transparent;
		border-top: 4px solid #333;
		border-radius: 3px
	}

	/* 默认箭头 */
	.m-tabs .item.arrow-down .txt {
		padding: 0 19px 0 6px;
		color: var(--themescolor)
	}

	.m-tabs .item.arrow-down .txt::after {
		content: " ";
		display: block;
		width: 0;
		height: 0;
		position: absolute;
		right: 6px;
		top: 20px;
		border: 4px solid transparent;
		border-top: 4px solid var(--themescolor);
		border-radius: 3px
	}

	/* 箭头向下 */
	.m-tabs .item.arrow-up .txt {
		padding: 0 19px 0 6px;
		color: var(--themescolor)
	}

	.m-tabs .item.arrow-up .txt::after {
		content: " ";
		display: block;
		width: 0;
		height: 0;
		position: absolute;
		right: 6px;
		top: 16px;
		border: 4px solid transparent;
		border-bottom: 4px solid var(--themescolor);
		border-radius: 3px
	}

	/* 箭头向上 */
	/* end 导航 */
	/* 结尾button */
	.b-btn {
		padding: 5px 10px;
		width: 95%
	}

	.b-btn .span {
		display: block;
		margin: 15px auto;
		width: 100%;
		height: 48px;
		line-height: 48px;
		font-size: 15px;
		text-align: center;
		border-radius: 3px
	}

	.b-btn a {
		display: block;
		margin: 15px auto;
		width: 100%;
		height: 48px;
		line-height: 48px;
		font-size: 15px;
		text-align: center;
		border-radius: 3px
	}

	.btn-r {
		background: var(--themescolor);
		color: #fff;
		border: 1px solid var(--themescolor);
		box-sizing: border-box
	}

	.btn-w {
		background: #fff;
		color: #666;
		border: 1px solid #ededed
	}

	/* end 结尾button */
	/* 横条图标加文字样式 */
	.entry-con {
		padding: 0 10px;
		line-height: 24px;
		background: #fff;
		cursor: pointer
	}

	.entry-con .con-box {
		padding: 10px 0;
		display: -webkit-flex;
		display: -webkit-box;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		border-bottom: 1px solid #f1f1f1
	}

	.entry-con .con-box .fl {
		display: block;
		-webkit-flex: 1;
		-ms-flex: 1;
		-webkit-box-flex: 1;
		-moz-box-flex: 1;
		flex: 1
	}

	.entry-con .con-box .entry-icon {
		display: inline-block;
		vertical-align: top;
		width: 18px;
		height: 18px;
		font-size: 0;
		margin-right: 5px;
		margin-top: 3px
	}

	.entry-con .con-box .entry-icon img {
		width: 100%;
		height: 100%
	}

	.entry-con .con-box .entry-name {
		display: inline-block;
		vertical-align: top;
		font-size: 14px
	}

	.entry-con .con-box .fr {
		display: block
	}

	.entry-con .con-box .entry-txt {
		display: inline-block;
		vertical-align: top;
		color: #999;
		font-size: 12px;
		font-family: arial
	}

	.entry-con .con-box .arr {
		display: inline-block;
		vertical-align: top;
		width: 14px;
		height: 14px;
		margin-top: 5px
	}

	.entry-con .con-box .arr img {
		width: 100%;
		height: 100%;
		vertical-align: top
	}

	.entry-con:last-of-type .con-box {
		border-bottom: 0
	}

	/* end 横条图标加文字样式 */
	/* 商品列表样式 */
	.pro-list {
		padding: 1px 0;
		width: 100%;
		display: -webkit-flex;
		display: -webkit-box;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap
	}

	.pro-list .pro-box {
		margin: 1px 0;
		position: relative;
		-webkit-flex-basis: 49.6%;
		flex-basis: 49.6%;
		background: #fff
	}

	.pro-list .pro-box:nth-child(odd) {
		margin-right: 1px
	}

	.pro-list .pro-box:nth-child(even) {
		margin-left: 1px
	}

	.pro-list .pro-box .pro-info {
		display: block;
		background: #fff;
		position: relative
	}

	.pro-list .pro-box .pro-img {
		display: block;
		text-align: center;
		background: #fff;
		position: relative;
		font-size: 0
	}

	.pro-list .pro-box .pro-img img {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0
	}

	.pro-list .pro-box .pro-img:before {
		content: " ";
		padding-top: 100%;
		display: inline-block;
		vertical-align: top
	}

	.pro-list .pro-box .pro-name {
		margin: 5px 10px 0;
		font-size: 14px;
		line-height: 18px;
		height: 36px;
		background: #fff;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-break: break-word;
		font-family: -apple-system, Helvetica, sans-serif
	}

	.pro-list .pro-box .pro-price {
		display: block;
		margin: 8px 10px 0;
		background: #fff;
		line-height: 16px;
		padding-bottom: 10px;
		font-size: 12px;
		color: var(--themescolor)
	}

	.pro-list .pro-box .pro-price .price {
		height: 16px;
		overflow: hidden
	}

	.pro-list .pro-box .pro-price .now {
		font-size: 16px;
		color: var(--themescolor)
	}

	.pro-list .pro-box .pro-price .dis {
		padding: 0 3px 0 2px;
		color: #fff;
		background: var(--themescolor);
		border-right: 1px dotted #fff;
		margin-left: 5px;
		font-size: 10px;
		vertical-align: top;
		display: inline-block;
		height: 14px;
		line-height: 14px;
		margin-top: 1px
	}

	.pro-list .pro-box .pro-com {
		padding: 0 10px 8px;
		background: #fff;
		line-height: 20px;
		margin-top: -8px
	}

	.pro-list .pro-box .pro-com .type-tag {
		margin-top: 2px
	}

	.pro-list .pro-box .pro-com .com-item {
		margin-right: 8px;
		color: #999;
		font-size: 12px;
		display: inline-block;
		vertical-align: top
	}

	/* end 商品列表样式 */
	/* 猜你喜欢 */
	.guess {
		margin-bottom: -2px
	}

	.guess .entry-con .con-box {
		border: 0
	}

	/* end 猜你喜欢 */
	/* 去掉默认滚动条 */
	::-webkit-scrollbar {
		width: 0;
		height: 0;
		color: transparent
	}

	.uni-input-placeholder {
		font-size: 14px !important;
		color: #bbb !important
	}
</style>
<style scoped>
	@import url("../../assets/auth.css");

	.right-top-sign {
		position: absolute;
		top: 40px;
		right: -15px;
		z-index: 95;
		box-sizing: border-box;
	}

	.right-top-sign:before {
		display: block;
		content: "";
		width: 200px;
		height: 40px;
		background: #89c0fc;
		border-radius: 0 50px 0 0;
		-webkit-transform: rotate(50deg);
		transform: rotate(50deg);
	}

	.right-top-sign:after {
		display: block;
		content: "";
		width: 200px;
		height: 40px;
		background: #89c0fc;
		border-radius: 50px 0 0 0;
		-webkit-transform: rotate(-50deg);
		transform: rotate(-50deg);
		position: absolute;
		right: -99px;
		top: 0;
	}

	.left-bottom-sign {
		position: absolute;
		left: -135px;
		bottom: -160px;
		border: 50px solid #d0d1fd;
		border-radius: 50%;
		padding: 90px;
	}

	.pl-2 {
		padding-left: 10px;
	}

	.border-secondary {
		border-color: var(--secondary) !important;
	}

	.border-left {
		border-left: 1px solid var(--bordercolor);
	}

	.font-28 {
		font-size: 14px;
	}
</style>
